import { ApiMethodCallback } from '../ApiMethod';
import { createSuccessResult } from '../ApiMethodResponseCreator';
import { MessageReadAdapter } from 'owa-addins-apis';
import { getAdapter } from '../../adapters/AdapterManager';

export default async function getAllInternetHeadersAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: null,
    callback: ApiMethodCallback
) {
    const adapter: MessageReadAdapter = getAdapter(hostItemIndex) as MessageReadAdapter;
    const result = await adapter.getAllInternetHeaders();
    callback(createSuccessResult(result));
}
